import React, { Component } from 'react';
import styled from 'styled-components';
import CollectionFilter from './CollectionFilter';
import Collection from './Collection';
import PropTypes from 'prop-types';

const Holder = styled.div`

`;

class CollectionHolder extends Component {
  state = {
    participantage: 'all',
    participantoccupation: 'all',
    participantlocation: 'all',
  };

  submitHandler = (values) => {
    this.setState({
      participantage: values.participantage,
      participantoccupation: values.participantoccupation,
      participantlocation: values.participantlocation,
    })
  };

  render() {
    return (
      <Holder>
        <CollectionFilter submitHandler={(values) => { this.submitHandler(values); }}/>
        <Collection
          avatarPrefix={this.props.avatarPrefix}
          participantage={this.state.participantage}
          participantoccupation={this.state.participantoccupation}
          participantlocation={this.state.participantlocation}/>
      </Holder>
    )
  }
}

CollectionHolder.propTypes = {
  avatarPrefix: PropTypes.string.isRequired
};

export default CollectionHolder;
